import React, {
	Component
} from 'react';
import { store } from '../stores/mainStore';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import {B64Image} from './B64Image';
// import {times} from 'lodash';



const HiddenPreloader = styled.div`
	display: none;
`


@observer
export class TutorialPreload extends Component {
	render() {
		return (
			<HiddenPreloader>
				<B64Image draggable="false" alt="" src={`/assets/languages/${store.settings.language}/tutorial_0a.png`}/>
				<B64Image draggable="false" alt="" src={`/assets/languages/${store.settings.language}/tutorial_16.png`}/>
				<B64Image draggable="false" alt="" src={`/assets/languages/${store.settings.language}/tutorial_17.png`}/>
			</HiddenPreloader>
		)
	}
}